import { render, staticRenderFns } from "./ChildProductMgmt.vue?vue&type=template&id=1e4f5972"
import script from "./ChildProductMgmt.vue?vue&type=script&lang=js"
export * from "./ChildProductMgmt.vue?vue&type=script&lang=js"
import style0 from "./ChildProductMgmt.vue?vue&type=style&index=0&id=1e4f5972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports